module.exports = __webpack_public_path__ + "img/republic-of-macedonia.7f3c8c0d.svg";